<template>
    <div class="_dflex _align-items-center">
        <div ref="target">
            <slot></slot>
        </div>
        <div class="copier" v-click-outside="hideCopy">
            <span class="ico ico-copy ico_color_gray-dark ico_size_16 _ml-8 _pointer" @click="copy"></span>
            <div class="copier__block" :class="{'copier__block_up': up}" v-if="isVisible">
                Скопировано
                <div class="copier__tile" :class="{'copier__tile_up': up}"></div>
            </div>
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import { Clipboard } from '../../assets/js/utils'

export default {
    name: 'UiCopier',
    directives: {
        ClickOutside,
    },
    props: {
        additionalClass: {
            type: String,
            default: ''
        },
        up: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isVisible: false
        }
    },
    methods: {
        copy() {
            this.isVisible = true;
            Clipboard.copy(this.$refs.target.innerText);
        },
        hideCopy() {
            if (this.isVisible) {
                this.isVisible = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/base/variables';
    @import '../../assets/scss/base/functions';
    @import '../../assets/scss/base/mixins';

    .copier {
        position: relative;

        &__block {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            @include fluid('margin-top', 4px, 8px);
            @include fluid('left', -44px);
            @include fluid('width', 114px);
            @include fluid('height', 40px);
            @include fluid('border-radius', 8px);
            @include fluid('font-size', 12px, 12px);
            @include fluid('line-height', 16px, 16px);
            background-color: $grey-517;
            color: $white-101;

            &_up {
                @include fluid('margin-top', -66px);
            }
        }

        &__tile {
            border: 8px solid transparent;
            border-right-color: $grey-517;
            position: absolute;
            @include fluid('left', 50px);
            @include fluid('top', -15px);
            transform: rotate(90deg);

            &_up {
                @include fluid('top', 40px);
                transform: rotate(270deg);
            }
        }
    }
</style>
